<template>
  <div class="platform">
    <template v-if="!bigState">
      <div class="title">
        <img class="bg-img" src="../assets/img/title/display-platform.png" />
        <!-- 天气 -->
        <div class="weather flex-y-center">
          <div class="w-icon flex-center">
            <img class="w-img" :src="weatherIcon[nowWeather.icon]" />
          </div>
          <div class="w-txt">
            <span>{{ nowWeather.temp || '暂无' }}</span>
            <span v-if="nowWeather.temp" class="s">℃</span>
            <span v-if="nowWeather.text" class="info">{{ nowWeather.text }}/{{ nowWeather.dew }}℃~{{ nowWeather.temp }}℃/风力{{ nowWeather.windScale }}级/湿度{{ nowWeather.humidity }}%</span>
          </div>
        </div>
        <!-- 时间 -->
        <div class="time flex-x-center">
          <div class="date flex-x-center">
            <div class="t">星期{{ dayStr }}</div>
            <div class="d">{{ dateStr }}</div>
          </div>
          <div class="time-info flex-y-center">{{ timeStr }}</div>
          <div class="login-state flex-center" @click="closePage">
            <img class="l-img" src="../assets/img/login/normal.png" />
          </div>
        </div>
      </div>
      <div class="content">
        <div class="n-part">
          <div class="nav-part flex-between">
            <div class="nav-item flex-center" @click="switchNav(1)">
              <img v-if="navIdx === 1" class="n-img" src="../assets/img/nav/zz-ac.png" />
              <img v-else class="n-img" src="../assets/img/nav/zz-nm.png" />
            </div>
            <div class="nav-item flex-center" @click="switchNav(2)">
              <img v-if="navIdx === 2" class="n-img" src="../assets/img/nav/nz-ac.png" />
              <img v-else class="n-img" src="../assets/img/nav/nz-nm.png" />
            </div>
            <div class="nav-item flex-center" @click="switchNav(3)">
              <img v-if="navIdx === 3" class="n-img" src="../assets/img/nav/jg-ac.png" />
              <img v-else class="n-img" src="../assets/img/nav/jg-nm.png" />
            </div>
          </div>
          <div v-if="navIdx == 1">
            <land-planting class="mgn-top-50"></land-planting>
            <category-proportion class="mgn-top-70"></category-proportion>
            <planting-scale class="mgn-top-70"></planting-scale>
          </div>
          <div v-if="navIdx == 2">
            <agricultural-materials-used class="mgn-top-50"></agricultural-materials-used>
            <agricultural-materials-rank class="mgn-top-70"></agricultural-materials-rank>
          </div>
          <div v-if="navIdx == 3">
            <processing-stage class="mgn-top-50"></processing-stage>
            <process-proportion class="mgn-top-70"></process-proportion>
            <processing-record class="mgn-top-70"></processing-record>
          </div>
        </div>
        <div class="item2">
          <div class="title-part flex-y-center">
            <div class="t-select1">
              <select-box :sty="true" :list="farmLandList" :item="selItem" @sel="selEvent" keyword="type"></select-box>
            </div>
          </div>
          <div id="mapData" ref="mapData" :key="mapKey" class="map"></div>
          <div class="weather">
            <box-model title="气象站" :cWidth="true">
              <template v-slot:content>
                <div class="w-content flex-between">
                  <div class="wc-left">
                    <div class="wc-cur flex-y-center">
                      <div class="wc-icon flex-center">
                        <img class="w-img" :src="weatherIcon[nowWeather.icon]" />
                      </div>
                      <div class="wc-info">
                        <div class="wc-n1">{{ nowWeather.temp || '暂无' }}°</div>
                        <div class="wc-n2">{{ nowWeather.text }}</div>
                        <div class="wc-n3">{{ nowWeather.dew }}/{{ nowWeather.temp }}℃</div>
                      </div>
                      <div class="line"></div>
                      <div class="wc-count">
                        <div class="c-item flex-between flex-y-center">
                          <span>湿度</span>
                          <span>{{ nowWeather.humidity }}%</span>
                        </div>
                        <div class="c-item flex-between">
                          <span>雨水</span>
                          <span>{{ nowWeather.precip }}mm</span>
                        </div>
                        <div class="c-item flex-between">
                          <span>风力</span>
                          <span>{{ nowWeather.windScale }}级</span>
                        </div>
                        <div class="c-item flex-between">
                          <span>光照强度</span>
                          <span>{{ nowWeather.cloud }}Lux</span>
                        </div>
                      </div>
                    </div>
                    <div class="wc-notice flex-y-center">
                      <img class="n-img" src="../assets/img/notice.png" />
                      <span>气象预警名称</span>
                      <span class="time">{{ nowWeather.timeStr || '' }}</span>
                    </div>
                  </div>
                  <div class="wc-right">
                    <div class="wc-r-list">
                      <div class="num-part">
                        <canvas class="canvas" width="1420px" height="64px" id="ctxs"></canvas>
                      </div>
                      <div v-for="(item, index) in baseList" :key="index" class="r-item">
                        <div class="r-time">{{ item.hourStr }}时</div>
                        <div class="r-tag"></div>
                        <img class="r-img" :src="weatherIcon[item.icon]" />
                        <div class="r-num">{{ item.temp }}℃</div>
                        <div class="r-wind">{{ item.text }}</div>
                        <div class="r-wind">{{ item.windScale }}级</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </box-model>
          </div>
        </div>
        <div class="n-part">
          <camera style="margin-top: 20px;"></camera>
          <soil-moisture class="mgn-top-70"></soil-moisture>
          <insect-survey class="mgn-top-70"></insect-survey>
        </div>
      </div>
    </template>
    <big-platform v-else></big-platform>  
  </div>
</template>
<script>
  import mapTag from "../assets/img/map-tag1.png";
  import * as echarts from "echarts";
  import "echarts-amap";
  import amQing from "../assets/img/weather/am-qing.png";
  import amDuoyun from "../assets/img/weather/am-duoyun.png";
  import pmQing from "../assets/img/weather/pm-qing.png";
  import pmDuoyun from "../assets/img/weather/pm-duoyun.png";
  import rain1 from "../assets/img/weather/rain1.png";
  import rain2 from "../assets/img/weather/rain2.png";
  import rain3 from "../assets/img/weather/rain3.png";
  import rain4 from "../assets/img/weather/rain4.png";
  import rain5 from "../assets/img/weather/rain5.png";
  import rain6 from "../assets/img/weather/rain6.png";
  import rain7 from "../assets/img/weather/rain7.png";
  import rain8 from "../assets/img/weather/rain8.png";
  import rain9 from "../assets/img/weather/rain9.png";
  import rain10 from "../assets/img/weather/rain10.png";
  import rain11 from "../assets/img/weather/rain11.png";
  import rain12 from "../assets/img/weather/rain12.png";
  import rain13 from "../assets/img/weather/rain13.png";
  import rain14 from "../assets/img/weather/rain14.png";
  import rain15 from "../assets/img/weather/rain15.png";
  import rain16 from "../assets/img/weather/rain16.png";
  import snow1 from "../assets/img/weather/snow1.png";
  import snow2 from "../assets/img/weather/snow2.png";
  import snow3 from "../assets/img/weather/snow3.png";
  import snow4 from "../assets/img/weather/snow4.png";
  import snow5 from "../assets/img/weather/snow5.png";
  import snow6 from "../assets/img/weather/snow6.png";
  import chen from "../assets/img/weather/chen.png";
  import mai from "../assets/img/weather/mai.png";
  import nodata from "../assets/img/weather/no.png";
  import shachen from "../assets/img/weather/shachen.png";
  import wu from "../assets/img/weather/wu.png";
  import yangsha from "../assets/img/weather/yangsha.png";
  import yin from "../assets/img/weather/yin.png";
  import { getFarmlandList, getFarmlandDetail } from "@/api/index";
  import autofit from "autofit.js";
  export default {
    data() {
      return {
        bigState: false,

        weatherIcon: {
          100: amQing,
          101: amDuoyun,
          102: amDuoyun,
          103: amDuoyun,
          104: yin,
          150: pmQing,
          151: pmDuoyun,
          152: pmDuoyun,
          153: pmDuoyun,
          300: rain16,
          301: rain14,
          302: rain12,
          303: rain12,
          304: rain13,
          305: rain2,
          306: rain3,
          307: rain4,
          308: rain5,
          309: rain1,
          310: rain6,
          311: rain6,
          312: rain6,
          313: rain2,
          314: rain2,
          315: rain3,
          316: rain4,
          317: rain5,
          318: rain6,
          350: rain11,
          351: rain11,
          399: rain3,
          400: snow1,
          401: snow2,
          402: snow3,
          403: snow4,
          404: rain3,
          405: rain3,
          406: rain15,
          407: snow2,
          408: snow1,
          409: snow2,
          410: snow3,
          456: snow5,
          457: snow3,
          499: snow2,
          500: wu,
          501: wu,
          502: mai,
          503: yangsha,
          504: chen,
          507: shachen,
          508: shachen,
          509: wu,
          510: wu,
          511: mai,
          512: mai,
          513: mai,
          514: wu,
          515: wu,
          900: amQing,
          901: yin,
          999: nodata
        },

        navIdx: 1,
        timeStr: '',
        dateStr: '',
        dayStr: '',

        mapObj: null,
        markers: [],
        mapKey: new Date().getTime(),

        baseList: [],
        // key: 'ede022eee7da4a09b8eee38ed1e3a2be',
        key: 'ba6db24b4f0b406c939d4963eb7688b5',
        nowWeather: {},
        farmLandList: [],
        farmLandDetail: {},
        selItem: {},
      }
    },
    components: {
      "land-planting": () => import('./components/LandPlanting.vue'),
      "category-proportion": () => import('./components/CategoryProportion.vue'),
      "planting-scale": () => import('./components/PlantingScale.vue'),
      "camera": () => import('./components/Camera.vue'),
      "soil-moisture": () => import('./components/SoilMoisture.vue'),
      "insect-survey": () => import('./components/InsectSurvey.vue'),
      "box-model": () => import("../components/common/Model.vue"),
      "agricultural-materials-used": () => import("./components/AgriculturalMaterialsUsed.vue"),
      "agricultural-materials-rank": () => import("./components/AgriculturalMaterialsRank.vue"),
      "processing-stage": () => import("./components/ProcessingStage.vue"),
      "process-proportion": () => import("./components/ProcessProportion.vue"),
      "processing-record": () => import("./components/ProcessingRecord.vue"),
      "select-box": () => import("../components/common/SelectBox.vue"),
      "big-platform": () => import("./BigPlatform.vue")
    },
    mounted() {
      if(window.screen.width < 3360){
        autofit.init({
          dh: 1080,
          dw: 1920,
          el: "#app",
          resize: true
        }, false)
        this.bigState = false;
        this.$nextTick(() => {
          this.getDate();
          this.getNowTime();
          this.getFarmlandListEvent();
        })
      } else {
        autofit.init({
          dh: 960,
          dw: 4480,
          el: "#app",
          resize: true
        }, false)
        this.bigState = true;
      }
    },
    methods: {
      switchNav(idx) {
        if(idx !== this.navIdx){
          this.navIdx = idx;
        }
      },
      initMap(callback){
        let that = this;
        let getItem = this.farmLandDetail;
        this.getCurCityData(getItem.cityText);
        AMap.plugin(
          ["AMap.DistrictSearch", "AMap.MapType", "AMap.CustomLayer"],
          function() {
            let district = new AMap.DistrictSearch({
              extensions: "all",
              level: "city",
            });
            district.search(getItem.name, function (status, result) {
              let bounds = result.districtList[0]?.boundaries;
              let districts = result.districtList[0]?.districtList;
              let cc = getItem.center;
              if(districts?.length){
                let findItem = districts.find((item) => item.name === getItem.countyText);
                if(findItem && findItem?.center?.lng && findItem?.center?.lat){
                  cc = [findItem?.center?.lng, findItem?.center?.lat];
                };
              };
              let mask = [];
              if(bounds?.length){
                for (let i = 0; i < bounds.length; i++) {
                  mask.push([bounds[i]]);
                };
              };
              let myChart = echarts.init(document.getElementById("mapData"));
              let option = {
                animation: false,
                amap: {
                  mask: mask,
                  center: cc,
                  viewMode: "3D",
                  zoom: 13,
                  defaultCursor: "auto",
                },
                series: [],
              };
              myChart.setOption(option);
              let map = myChart.getModel().getComponent("amap").getAMap();
              let mapType = new AMap.MapType({
                defaultType: 1,
                showTraffic: true,
                showRoad: true
              });
              map.addControl(mapType);
              mapType.hide();
              // 名字
              let LabelsData = [];
              if(districts?.length){
                for (let i = 0; i < districts.length; i++) {
                  let config = {
                    name: "",
                    zooms: [4, 13],
                    zIndex: 1,
                    opacity: 1,
                    text: {
                      content: "",
                      direction: "center",
                      offset: [0, 0],
                      zooms: [3, 20],
                      style: {
                        fontSize: 12,
                        fontWeight: "normal",
                        fillColor: "#fff",
                        strokeColor: "rgba(0,0,0,1)",
                        strokeWidth: 1,
                      },
                    },
                  };
                  let district = districts[i];
                  let name = district.name;
                  config.text.content = name;
                  config.position = [district.center.lng, district.center.lat];
                  LabelsData.push(config);
                  let district2 = new AMap.DistrictSearch({
                    extensions: "all",
                    level: "district",
                  });
                  if(bounds?.length){
                    district2.search(name, function (status, result) {
                      for (let ii = 0; ii < bounds.length; ii++) {
                        new AMap.Polyline({
                          map: map,
                          path: bounds[ii],
                          strokeColor: "#2687D0",
                          strokeWeight: 2,
                        });
                      }
                    });
                  }
                };
              };
              // 边界
              if(bounds?.length){
                for (let i = 0; i < bounds.length; i++) {
                  new AMap.Polyline({
                    map: map,
                    path: bounds[i],
                    strokeColor: "#2687D0",
                    strokeWeight: 6,
                  });
                };
              };
              map.on("complete", function () {
                that.setMapBg();
                that.mapObj = map;
                if(typeof callback === 'function'){
                  callback();
                };
                let layer = new AMap.LabelsLayer({
                  collision: false,
                  animation: false,
                });
                // 名称绘制
                for (let i = 0; i < LabelsData.length; i++) {
                  let labelsMarker = new AMap.LabelMarker(LabelsData[i]);
                  layer.add(labelsMarker);
                };
                map.add(layer);
                // 绘制自定义区域
                const polygon = new AMap.Polygon({
                  path: getItem.pointArray,
                  strokeColor: '#18FEFE',
                  strokeWeight: 2,
                  strokeOpacity: 0.5,
                  fillOpacity: 0.1,
                  fillColor: '#38EAFF',
                  zIndex: 50
                });
                map.add(polygon);
              });
            })
          }
        );
      },
      // 地图背景透明设置
      setMapBg() {
        let timer = null;
        let ele = document.getElementsByClassName("amap-container");
        if(ele?.length){
          timer && clearInterval(timer);
          ele[0].style.background = "none";
          timer = null;
        } else {
          timer = setInterval(() => {
            this.setMapBg();
          }, 1000);
        }
      },
      // 获取当前时间
      getNowTime() {
        this.timer = setInterval(() => {
          const date = new Date();
          const s = date.getSeconds(),
          m = date.getMinutes(),
          h = date.getHours();
          this.timeStr = `${this.dbNum(h)}:${this.dbNum(m)}:${this.dbNum(s)}`;
        }, 1000);
      },
      dbNum(num) {
        return num > 9 ? num : '0'+num;
      },
      // 获取年月日
      getDate() {
        const date = new Date();
        const y = date.getFullYear(),
          M = date.getMonth() + 1,
          d = date.getDate(),
          day = date.getDay();
        this.dateStr = `${y}/${this.dbNum(M)}/${this.dbNum(d)}`;
        const num = ['日','一','二','三','四','五','六']
        this.dayStr = num[day];
      },
      closePage() {
        localStorage.removeItem("st");
        window.close();
      },
      // 获取当前城市的经纬度
      getCurCityData(name){
        fetch(`https://geoapi.qweather.com/v2/city/lookup?location=${name}&key=${this.key}`).then((res) => {
          res.json().then((data) => {
            let item = data.location[0];
            this.getCurWeather(`${item.lon},${item.lat}`);
            this.get24HWeather(`${item.lon},${item.lat}`);
          })
        })
      },
      // 获取当前天气
      getCurWeather(location) {
        fetch(`https://devapi.qweather.com/v7/grid-weather/now?location=${location}&key=${this.key}`).then((res) => {
          res.json().then((data) => {
            const result = data.now || {};
            let date = new Date(result.obsTime);
            let y = date.getFullYear(),
              M = this.dbNum(date.getMonth() + 1),
              d = this.dbNum(date.getDay()),
              h = this.dbNum(date.getHours()),
              m = this.dbNum(date.getMinutes()),
              s = this.dbNum(date.getSeconds());
            result['timeStr'] = `${y}-${M}-${d} ${h}:${m}:${s}`;
            this.nowWeather = result;
          })
        })
      },
      // 获取未来24h小时天气
      get24HWeather(location) {
        fetch(`https://devapi.qweather.com/v7/weather/24h?location=${location}&key=${this.key}`).then((res) => {
          res.json().then((data) => {
            const result = data.hourly || [];
            let tempMax = 0, tempMin = 0;
            result.forEach((item) => {
              let date = new Date(item.fxTime);
              item['hourStr'] = date.getHours();
              tempMax = Math.max(tempMax, +item.temp);
              tempMin = Math.min(tempMin, +item.temp);
            });
            tempMax = tempMax + 20;  // 最高温度加6个点
            tempMin = tempMin - 20;  // 最小温度减6个点
            let total = tempMax - tempMin;
            // 高 64
            // 宽 40
            // 坐标点计算
            result.forEach((item) => {
              let step = (+item.temp);
              item['ysn'] = (64/total)*step;
            });
            this.baseList = result;
            this.drawLineEvent(result);
          })
        })
      },
      // 画线
      drawLineEvent(arr){
        let c = document.getElementById('ctxs');
        let ctx = c.getContext("2d");
        let xStart = 18;
        let step = 60;
        ctx.beginPath();
        ctx.moveTo(xStart, arr[0].ysn);
        ctx.lineTo(xStart + 1*step, arr[1].ysn);
        ctx.lineTo(xStart + 2*step, arr[2].ysn);
        ctx.lineTo(xStart + 3*step, arr[3].ysn);
        ctx.lineTo(xStart + 4*step, arr[4].ysn);
        ctx.lineTo(xStart + 5*step, arr[5].ysn);
        ctx.lineTo(xStart + 6*step, arr[6].ysn);
        ctx.lineTo(xStart + 7*step, arr[7].ysn);
        ctx.lineTo(xStart + 8*step, arr[8].ysn);
        ctx.lineTo(xStart + 9*step, arr[9].ysn);
        ctx.lineTo(xStart + 10*step, arr[10].ysn);
        ctx.lineTo(xStart + 11*step, arr[11].ysn);
        ctx.lineTo(xStart + 12*step, arr[12].ysn);
        ctx.lineTo(xStart + 13*step, arr[13].ysn);
        ctx.lineTo(xStart + 14*step, arr[14].ysn);
        ctx.lineTo(xStart + 15*step, arr[15].ysn);
        ctx.lineTo(xStart + 16*step, arr[16].ysn);
        ctx.lineTo(xStart + 17*step, arr[17].ysn);
        ctx.lineTo(xStart + 18*step, arr[18].ysn);
        ctx.lineTo(xStart + 19*step, arr[19].ysn);
        ctx.lineTo(xStart + 20*step, arr[20].ysn);
        ctx.lineTo(xStart + 21*step, arr[21].ysn);
        ctx.lineTo(xStart + 22*step, arr[22].ysn);
        ctx.lineTo(xStart + 23*step, arr[23].ysn);
        ctx.lineWidth = 1;
        ctx.strokeStyle = "#ffffff";
        ctx.stroke();
        this.dreawPoint(ctx, xStart, arr[0].ysn);
        this.dreawPoint(ctx, xStart + 1*step, arr[1].ysn);
        this.dreawPoint(ctx, xStart + 2*step, arr[2].ysn);
        this.dreawPoint(ctx, xStart + 3*step, arr[3].ysn);
        this.dreawPoint(ctx, xStart + 4*step, arr[4].ysn);
        this.dreawPoint(ctx, xStart + 5*step, arr[5].ysn);
        this.dreawPoint(ctx, xStart + 6*step, arr[6].ysn);
        this.dreawPoint(ctx, xStart + 7*step, arr[7].ysn);
        this.dreawPoint(ctx, xStart + 8*step, arr[8].ysn);
        this.dreawPoint(ctx, xStart + 9*step, arr[9].ysn);
        this.dreawPoint(ctx, xStart + 10*step, arr[10].ysn);
        this.dreawPoint(ctx, xStart + 11*step, arr[11].ysn);
        this.dreawPoint(ctx, xStart + 12*step, arr[12].ysn);
        this.dreawPoint(ctx, xStart + 13*step, arr[13].ysn);
        this.dreawPoint(ctx, xStart + 14*step, arr[14].ysn);
        this.dreawPoint(ctx, xStart + 15*step, arr[15].ysn);
        this.dreawPoint(ctx, xStart + 16*step, arr[16].ysn);
        this.dreawPoint(ctx, xStart + 17*step, arr[17].ysn);
        this.dreawPoint(ctx, xStart + 18*step, arr[18].ysn);
        this.dreawPoint(ctx, xStart + 19*step, arr[19].ysn);
        this.dreawPoint(ctx, xStart + 20*step, arr[20].ysn);
        this.dreawPoint(ctx, xStart + 21*step, arr[21].ysn);
        this.dreawPoint(ctx, xStart + 22*step, arr[22].ysn);
        this.dreawPoint(ctx, xStart + 23*step, arr[23].ysn);
      },
      dreawPoint(ctx, cx, cy){
        ctx.save();
        ctx.lineWidth = 1
        ctx.beginPath()
        ctx.arc(cx, cy, 2, 0, Math.PI * 2)
        ctx.fillStyle = "#ffffff"
        ctx.fill()
        ctx.strokeStyle = "#ffffff"
        ctx.stroke()
        ctx.closePath()
        ctx.restore()
      },
      // 获取地块下拉列表
      getFarmlandListEvent(){
        getFarmlandList().then((res) => {
          const result = res.data || [];
          result.forEach((item) => {
            item['name'] = item.desc
          });
          this.farmLandList = result;
          // 广东 茂名市 茂南区
          let findItem = result.find((item) => {
            return item.name.indexOf("茂名市") > -1 || item.name.indexOf("茂南区") > -1;
          });
          if(findItem){
            this.getFarmlandDetailEvent(findItem);
          } else {
            this.getFarmlandDetailEvent(result[0]);
          };
        })
      },
      getFarmlandDetailEvent(item){
        if(!item || !item?.type){
          return;
        }
        this.selItem = item;
        getFarmlandDetail(item.type).then((res) => {
          const result = res.data || {};
          result["name"] = result.cityText;
          let pArr = result.pointArr ? JSON.parse(result.pointArr) : "";
          if(pArr && pArr?.length){
            result['pointArray'] = pArr;
            result["center"] = pArr[0];
          };
          this.farmLandDetail = result;
          this.mapKey = new Date().getTime();
          this.initMap();
        });
      },
      selEvent(item){
        this.selItem = item;
        this.getFarmlandDetailEvent(item);
      }
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }
</script>
<style scoped lang="less">
  @import url("../assets/css/title.less");
  .platform {
    width: 100%;
    height: 100%;
    .content {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: calc(100% - 105px);
      padding: 14px 30px;
      overflow: hidden;
      .n-part {
        position: relative;
        width: 440px;
        height: 100%;
        padding: 10px 0 20px 0;
        overflow-y: scroll;
        overflow-x: hidden;
        .mgn-top-70 {
          margin-top: 70px;
        }
        .mgn-top-50 {
          margin-top: 50px;
        }
        .nav-part {
          width: 100%;
          height: 40px;
          .nav-item {
            width: 138px;
            height: 40px;
            cursor: pointer;
            .n-img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .item2 {
        position: relative;
        width: 1100px;
        height: 100%;
        margin: 0 20px;
        .title-part {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 9;
          width: 100%;
          height: 32px;
          .t-select1 {
            position: absolute;
            right: 0;
            top: 0;
            width: 200px;
          }
        }
        .map {
          width: 100%;
          height: 690px;
        }
        .weather {
          width: 1100px;
          height: 202px;
          margin-top: 50px;
          .w-content {
            width: 100%;
            height: 100%;
            .wc-left {
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              width: 380px;
              height: 160px;
              .wc-cur {
                width: 100%;
                height: 100px;
                .wc-icon {
                  width: 100px;
                  height: 100%;
                  margin-right: 20px;
                  .w-img {
                    width: 80px;
                    height: 80px;
                  }
                }
                .wc-info {
                  width: 80px;
                  height: 100%;
                  color: #4ADDFF;
                  .wc-n1 {
                    font-size: 36px;
                    font-weight: 700;
                    line-height: 36px;
                  }
                  .wc-n2 {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 14px;
                    margin-top: 16px;
                  }
                  .wc-n3 {
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 16px;
                    margin-top: 12px;
                  }
                }
                .line {
                  width: 1px;
                  height: 100%;
                  background: #243256;
                  margin: 0 20px;
                }
                .wc-count {
                  width: 140px;
                  height: 100%;
                  .c-item {
                    width: 100%;
                    height: 25%;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(255,255,255,0.702);
                  }
                }
              }
              .wc-notice {
                width: 100%;
                height: 40px;
                background: rgba(9,148,255,0.14);
                margin-top: 20px;
                padding: 0 10px;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                .n-img {
                  width: 24px;
                  height: 24px;
                  margin-right: 10px;
                }
                .time {
                  margin-left: auto;
                  font-size: 14px;
                  font-weight: 400;
                  color: #4ADDFF;
                }
              }
            }
            .wc-right {
              width: 660px;
              height: 160px;

              .wc-r-list {
                position: relative;
                width: 100%;
                height: 160px;
                overflow-x: scroll;
                overflow-y: hidden;
                white-space: nowrap;
                .num-part {
                  position: absolute;
                  z-index: 3;
                  left: 0;
                  top: 20px;
                  width: 1420px;
                  height: 40px;
                }
                .r-item {
                  display: inline-block;
                  width: 40px;
                  height: 100%;
                  margin-right: 20px;
                  overflow: hidden;
                  cursor: pointer;
                  .r-time {
                    font-size: 14px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 16px;
                    text-align: center;
                  }
                  .r-tag {
                    width: 100%;
                    height: 40px;
                    margin-top: 4px;
                  }
                  .r-img {
                    display: block;
                    width: 32px;
                    height: 32px;
                    margin: 0 auto;
                  }
                  .r-num {
                    font-size: 15px;
                    font-weight: 700;
                    color: #FFFFFF;
                    line-height: 16px;
                    text-align: center;
                    margin-top: 6px;
                  }
                  .r-wind {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(255,255,255,0.702);
                    line-height: 14px;
                    text-align: center;
                    margin-top: 6px;
                  }
                }
                .r-item:last-child {
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
